'use strict';

var React = require('react');

var SvgTransactionFeeDollarMajor = function SvgTransactionFeeDollarMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13c-1.103 0-2-.897-2-2v-7h5.185a2.995 2.995 0 0 0 2.815 2c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.997 2.997 0 0 0-2.816 2h-8.368a2.997 2.997 0 0 0-2.816-2c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.997 2.997 0 0 0 2.816-2h1.184v7c0 2.206 1.794 4 4 4a1 1 0 0 0 0-2zm5.977-2c.026.001.649.04 1.316.707a1 1 0 0 0 1.414-1.414 4.49 4.49 0 0 0-1.707-1.093v-.2a1 1 0 0 0-2 0v.185a2.995 2.995 0 0 0-2 2.815c0 2.28 1.725 2.712 2.756 2.97h.002c1.115.279 1.242.384 1.242 1.03 0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a1 1 0 0 0-1.414 1.414c.479.49 1.062.863 1.707 1.093v.2a1 1 0 0 0 2 0v-.185a2.992 2.992 0 0 0 2-2.815c0-2.28-1.725-2.712-2.756-2.97h-.001c-1.115-.279-1.243-.384-1.243-1.03 0-.552.449-1 .977-1z"
  }));
};

exports.SvgTransactionFeeDollarMajor = SvgTransactionFeeDollarMajor;
